import React from 'react';
import Leaderboard from '../components/leaderboard/Leaderboard';

const LeaderboardPage = () => {
  return <Leaderboard />;
};

export default LeaderboardPage;